<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    class="tab-bar"
    active-color="#ffd1d9"
    inactive-color="#8f858b"
    safe-area-inset-bottom
  >
    <van-tabbar-item
      v-for="item in navigation"
      :key="item.name"
      :to="item.to"
      :icon="item.icon"
      :aria-label="item.displayLabel"
    >
      <span class="tab-label">{{ item.displayLabel }}</span>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
      navigation: [
        { name: 'home', to: '/Home', icon: 'wap-home-o', displayLabel: 'Home' },
        { name: 'MessageBoard', to: '/MessageBoard', icon: 'clock-o', displayLabel: 'History' },
        { name: 'game_n', to: '/GameN', icon: 'like-o', displayLabel: 'Favorite' },
        { name: 'video', to: '/Video', icon: 'video-o', displayLabel: 'Film' },
        { name: 'mine', to: '/Mine', icon: 'user-o', displayLabel: 'Profile' }
      ]
    }
  },
  methods: {
    syncRoute(route) {
      const index = this.navigation.findIndex(item => item.name === route.name)
      this.show = index !== -1
      if (index !== -1) {
        this.active = index
      }
    }
  },
  watch: {
    $route(to) {
      this.syncRoute(to)
    }
  },
  created() {
    this.syncRoute(this.$route)
  }
}
</script>

<style lang="less" scoped>
.tab-bar {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  height: 1.82rem;
  padding: 0.1rem 0.12rem calc(0.1rem + env(safe-area-inset-bottom));
  background: rgba(13, 11, 14, 0.94);
  border-top: 1px solid rgba(231, 160, 174, 0.38);
  box-shadow: 0 -0.24rem 0.65rem rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

::v-deep .van-tabbar-item {
  min-width: 0;
  margin: 0 0.035rem;
  border: 1px solid transparent;
  border-radius: 0.34rem;
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

::v-deep .van-tabbar-item .van-icon {
  margin-bottom: 0.05rem;
  font-size: 0.54rem;
}

.tab-label {
  display: block;
  max-width: 100%;
  overflow: hidden;
  font-size: 0.21rem;
  font-variant-caps: small-caps;
  font-weight: 500;
  letter-spacing: 0.025rem;
  line-height: 1.1;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

::v-deep .van-tabbar-item--active {
  background: linear-gradient(145deg, rgba(75, 49, 60, 0.36), rgba(26, 20, 25, 0.74));
  border-color: rgba(231, 160, 174, 0.42);
  box-shadow: inset 0 0 0.4rem rgba(231, 160, 174, 0.08), 0 0 0.28rem rgba(231, 160, 174, 0.08);
}
</style>
